import { matchPath, useLocation } from "react-router-dom";

import { getValueFromLinkState } from "seneca-common/utils/routing";

import { linkToParentDashboard } from "features/parents/routes/links";

export function useIsParentSignIn() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const connectionKey = searchParams.get("connectionKey");

  if (connectionKey) return true;

  const redirectAuthUserTo = getValueFromLinkState<
    string | { pathname: string }
  >(location, "redirectAuthenticatedUserToLocation");

  if (!redirectAuthUserTo) {
    return false;
  }

  const redirectLink =
    typeof redirectAuthUserTo === "string"
      ? redirectAuthUserTo
      : redirectAuthUserTo.pathname;

  return !!matchPath(redirectLink, {
    path: linkToParentDashboard()
  });
}
